import React, { useState, useEffect } from 'react';
import { TabContext } from './context/TabContext';
import Tab from './components/Tab';
import Nav from './components/Nav';
import Panel from './components/Panel';
import styles from './Tabs.module.scss';
// @ts-ignore
import classNames from 'classnames';

type PropsType = {
  initIndex: string;
  className?: string;
  children: React.ReactNode;
  dataCy?: string;
};

const Tabs = (props: PropsType) => {
  const [currentIndex, setCurrentIndex] = useState<string>(props.initIndex);
  const [content, setContent] = useState<React.ReactNode>();

  const handleOnSelectTab = (index: string, content: React.ReactNode) => {
    setContent(content);
    setCurrentIndex(index);
  };

  useEffect(() => {
    setCurrentIndex(props.initIndex);
  }, [props.initIndex]);

  return (
    <TabContext.Provider
      value={{
        initIndex: props.initIndex,
        currentIndex,
        content,
        onSelectTab: handleOnSelectTab,
      }}
    >
      <div
        className={classNames(styles.wrapper, props.className)}
        data-cy={props.dataCy}
      >
        {props.children}
      </div>
    </TabContext.Provider>
  );
};

Tabs.Nav = Nav;
Tabs.Tab = Tab;
Tabs.Panel = Panel;

export default Tabs;
